module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M29.933 0H1.996C.892 0 0 .99 0 2.091v21.951c0 1.104.892 1.9 1.996 1.9h7.156l5.402 5.45c.389.391.9.609 1.411.609s1.022-.231 1.411-.621l5.402-5.438h7.156c1.104 0 1.995-.796 1.995-1.9V2.091C31.929.989 31.037 0 29.934 0zm-6.957 13.959l-6.122 6.585a.925.925 0 0 1-1.379 0l-6.122-6.585c-1.559-1.62-1.559-4.242 0-5.863a3.894 3.894 0 0 1 5.649 0l1.161 1.467 1.161-1.467a3.896 3.896 0 0 1 5.651 0c1.558 1.62 1.558 4.242 0 5.863z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/heart-comment-1.js
// module id = 1171
// module chunks = 14